export default __webpack_public_path__ + "static/media/logo-en-lee.07eb9ca2.png";